export const sessionItem = {
  set: function(key, value) {
    return sessionStorage.setItem(key, value);
  },
  get: function(key) {
    return sessionStorage.getItem(key);
  },
  remove:function(key){
      return sessionStorage.removeItem(key)
  },
  clear:function(){
      return sessionStorage.clear();
  }
};
